import AllRanges from "./AllRanges";

export default AllRanges;
